// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"cf83ab7a","889":"1a055ced","1449":"1a055ced","4130":"346a5a76","6302":"1a055ced","9658":"1a055ced"}[chunkId] + ".chunk.css";
};